/**
 * frequently-bought-together.js — bundle row add-to-cart
 */
(function () {
  'use strict';

  function qsa(sel, ctx) {
    return [...(ctx || document).querySelectorAll(sel)];
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    thousands = thousands || ',';
    decimal = decimal || '.';

    if (isNaN(number) || number == null) {
      return '0';
    }

    var fixed = number.toFixed(precision);
    var parts = fixed.split('.');
    var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    var cents = parts[1] ? decimal + parts[1] : '';

    return dollars + cents;
  }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }

    var formatString = format || '${{amount}}';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var match = formatString.match(placeholderRegex);

    if (!match) {
      return String(cents / 100);
    }

    var value = '';

    switch (match[1]) {
      case 'amount':
        value = formatWithDelimiters(cents / 100, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents / 100, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents / 100, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents / 100, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents / 100, 2, "'", '.');
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents / 100, 2, ' ', ',');
        break;
      default:
        value = formatWithDelimiters(cents / 100, 2);
    }

    return formatString.replace(placeholderRegex, value);
  }

  function getMoneyFormat(bundle) {
    var section = bundle.closest('[data-nb-fbt-section]');
    return (section && section.dataset.moneyFormat) || '${{amount}}';
  }

  function buttonLabel(count, template) {
    if (count <= 1) {
      return 'Add To Cart';
    }
    if (count === 2) {
      return 'Add Both To Cart';
    }
    var labelTemplate = template || 'Add all {count} to Cart';
    return labelTemplate.replace(/\{count\}/g, String(count));
  }

  function initBundle(bundle) {
    var btn = bundle.querySelector('[data-nb-bundle-add]');
    var totalEl = bundle.querySelector('[data-fbt-total]');
    var moneyFormat = getMoneyFormat(bundle);
    var labelTemplate = (btn && btn.dataset.buttonLabelTemplate) || 'Add all {count} to Cart';

    function checkedItems() {
      return qsa('[data-fbt-item]', bundle).filter(function (item) {
        var cb = item.querySelector('[data-fbt-checkbox]');
        return cb && cb.checked;
      });
    }

    function updateBundle() {
      var items = checkedItems();
      var total = 0;
      var ids = [];

      items.forEach(function (item) {
        total += Number(item.dataset.price) || 0;
        if (item.dataset.variantId) ids.push(item.dataset.variantId);
      });

      if (totalEl) totalEl.textContent = formatMoney(total, moneyFormat);
      if (btn) {
        btn.dataset.variantIds = ids.join(',');
        btn.disabled = ids.length === 0;
        btn.textContent = buttonLabel(ids.length, labelTemplate);
      }
    }

    qsa('[data-fbt-checkbox]', bundle).forEach(function (cb) {
      cb.addEventListener('change', updateBundle);
    });

    updateBundle();
  }

  function initBundles(section) {
    if (section.dataset.previewMode !== undefined) return;

    qsa('[data-nb-bundle-add]', section).forEach(function (btn) {
      btn.addEventListener('click', async function () {
        var ids = (btn.dataset.variantIds || '').split(',').filter(Boolean);
        if (!ids.length) return;

        var items = ids.map(function (id) {
          return { id: parseInt(id, 10), quantity: 1 };
        });

        btn.disabled = true;
        var original = btn.textContent;

        try {
          var response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: items })
          });

          if (!response.ok) throw new Error('Bundle add failed');

          document.dispatchEvent(new CustomEvent('cart:updated'));
          btn.textContent = '✓ Added!';
          btn.classList.add('is-added');

          setTimeout(function () {
            btn.disabled = false;
            btn.classList.remove('is-added');
            btn.closest('[data-nb-fbt-bundle]') && initBundle(btn.closest('[data-nb-fbt-bundle]'));
          }, 2000);
        } catch (err) {
          btn.disabled = false;
          btn.textContent = original;
          console.error('NB bundle error:', err);
        }
      });
    });
  }

  function initSection(section) {
    qsa('[data-nb-fbt-bundle]', section).forEach(initBundle);
    initBundles(section);
  }

  function init() {
    qsa('[data-nb-fbt-section]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('[data-nb-fbt-section]');
    if (section) initSection(section);
  });
})();
